import {
  mapKeys,
  mapValues,
  camelCase,
  snakeCase,
  isPlainObject,
  isArray,
} from 'lodash';

function convertKeysDeep<T>(input: T, converter: (key: string) => string): T {
  if (isArray(input)) {
    return input.map((val) => convertKeysDeep(val, converter)) as unknown as T;
  } else if (isPlainObject(input)) {
    const objectInput = input as Record<string, unknown>;
    const mapped = mapValues(
      mapKeys(objectInput, (_val, key) => converter(key)),
      (val) => convertKeysDeep(val, converter)
    );
    return mapped as unknown as T;
  }
  return input;
}

// This function converts camel case variable names to snake case
export function toSnakeCase<T>(data: T): T {
  return convertKeysDeep(data, snakeCase);
}

// This function converts snake case variable names to camel case
export function toCamelCase<T>(data: T): T {
  return convertKeysDeep(data, camelCase);
}
